enum CompanyType {
  Hybrid = 'Hybrid',
  Client = 'Client',
  Manufacturer = 'Manufacturer',
}

export default CompanyType;
